module.exports = __webpack_public_path__ + "assets/img/71b3-ci.svg";